import { render, staticRenderFns } from "./hocTask.vue?vue&type=template&id=3e2a3a94&"
import script from "./hocTask.vue?vue&type=script&lang=js&"
export * from "./hocTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports